import * as React from "react";
import { useEffect, useState } from "react";
import {
    faIR,
    GridDeleteIcon,
    DataGrid
  } from "@mui/x-data-grid";
  import { useDispatch, useSelector } from "react-redux";
  import { Box, Grid,Typography, IconButton, Button } from "@mui/material";
  import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
  import { setinitialStateR } from "../../../components/Login/LoginSlice/LoginSlice";
  import "./style.css";
  import {
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
  } from "@mui/x-data-grid";
  import Dialog from '@mui/material/Dialog';
  import DialogActions from '@mui/material/DialogActions';
  import DialogTitle from '@mui/material/DialogTitle';
  import useMediaQuery from '@mui/material/useMediaQuery';
  import { useTheme } from '@mui/material/styles';
  
  export default function DYCustom({
    data = [],
    columns = [],
    hideFooter,
    selectionModel,
    initialOnRowClick,
    rowSelection,
    rowHeight,
    onRowSelectionEvent,
    initState,
    setSelectionModel,
    setShowHistory,
    additionalToolbar,
    setShowInformation,
    setSpecialId,
    setShowAddEvalModal,
    initialDelete,
    setShowActionsModal,
    initialMount,
    setPointSys,
    drName,
    setRowSelectedData,
    withoutOptions,
  }: any) {
    const [selectedRowData, setSelectedRowData] = React.useState(null);
    const [columnVisibilityModel, setColumnVisibilityModel] = useState(() => {
      const savedVisibility = localStorage.getItem('updateByVisibility');
      return savedVisibility ? JSON.parse(savedVisibility) : { updateBy: false }; // پیش‌فرض false
    });
  
    // ذخیره وضعیت جدید در localStorage هر بار که تغییر کند
    useEffect(() => {
      localStorage.setItem('updateByVisibility', JSON.stringify(columnVisibilityModel));
    }, [columnVisibilityModel]);
  
    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
    
    function CustomToolbar() {
      return (
        <GridToolbarContainer>
          <Grid>
            {selectedRowData && additionalToolbar && (
              <Button
                sx={{ fontSize: "10px" }}
                variant="text"
                onClick={() => {
                  setShowHistory((prev: any) => !prev);
                  let { id } = selectedRowData;
                  setSpecialId(id);
                }}
                startIcon={<HistoryToggleOffIcon />}
              >
                ویرایش
              </Button>
            )}
            {selectedRowData && additionalToolbar && (
              <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title" fontWeight={600} fontSize={'17px'}>
          {"آیا از حذف اطمینان دارید؟"}
          </DialogTitle>
          <DialogActions>
            <Button autoFocus onClick={handleClose}>
            <Typography  color={'red'}> انصراف</Typography> 
            </Button>
            <Button       
               onClick={() => {
                  let { id } = selectedRowData;
                  setSpecialId(id);
                  initialDelete();
                  handleClose()
                }} autoFocus >
            <Typography  color={'#00387C'} > تایید</Typography> 
            </Button>
          </DialogActions>
        </Dialog>
          )}
            {selectedRowData && additionalToolbar && (
              <Button
                sx={{ fontSize: "10px" }}
                variant="text"
                onClick={handleClickOpen}
                startIcon={<GridDeleteIcon />}
              >
                حذف
              </Button>
            )}
          </Grid>
          <GridToolbarColumnsButton sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />
<GridToolbarFilterButton sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />
<GridToolbarDensitySelector sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />

        </GridToolbarContainer>
      );
    }
    //قدیم
    // const initOnRowClick = (row: any) => {
    //   setSelectionModel(row.id);
    //   setSelectedRowData(row);
    //   initialOnRowClick(row);
    //   if (setPointSys) {
    //     setPointSys(row?.okR_KeyResultType);
    //   }
    //   if (setRowSelectedData) {
    //     setRowSelectedData(row);
    //   }
    // };
  
    const initOnRowClick = (row: any) => {
      setSelectionModel(row.id);
      setSelectedRowData(row);
      initialOnRowClick(row);
      if (setPointSys) {
        setPointSys(row?.okR_KeyResultType);
      }
      if (setRowSelectedData) {
        setRowSelectedData(row);
      }
    };

    useEffect(() => {
      if (initialMount) {
        setSelectedRowData(data[0]);
        initialOnRowClick(data[0]);
      }
  
      if (setPointSys) {
        setPointSys(data[0]?.okR_KeyResultType);
      }
  
      if (setRowSelectedData) {
        setRowSelectedData(data[0]);
      }
    }, []);
  
    useEffect(() => {
      if (selectionModel && data.length > 0) {
        const selectedRow = data.find((row: any) => row.id === selectionModel);
        setSelectedRowData(selectedRow || null);
      }
    }, [selectionModel, data]);

    const dispatch = useDispatch();
  
    const initialChangestate = (data: any) => {
      if (drName && data) {
        let columnVisibilityModel = data?.columns?.columnVisibilityModel;
  
        try {
          dispatch(
            setinitialStateR({ name: drName, colVis: columnVisibilityModel })
          );
        } catch (error) {
          console.log(error);
        }
      }
    };
  
    return (
      <Grid width={"100%"}>
                    <div style={{ height: 450, width: '100%' }}> {/* ارتفاع و عرض محدود شده */}
        <DataGrid
          onStateChange={(state:any) => {
            initialChangestate(state);
          }}
          density="compact"
          initialState={initState}
          slots={{ toolbar: withoutOptions ? null : CustomToolbar }}
          rowHeight={40}
          sx={{
            cursor: "pointer",
            border: 0,
            "& .MuiDataGrid-columnSeparator": {
              display: "none!important",
            },
            "& .MuiDataGrid-root": {
              backgroundColor: "#00387C !important",
              color: "white",
              borderRadius: 4,
              cursor: "pointer",
              border: 0,
              "& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell": {
                fontSize: "10px", // Adjust the font size as needed
              },
              "& .rtl-128fb87-MuiDataGrid-toolbarContainer": {
                alignSelf: "end",
                pb: 2,
              },
            },
            "& .MuiDataGrid-columnHeaders": {
              width: "100%",
              position: "sticky",
              zIndex: "1000",
              borderRadius: 0,
              background: "#00387C !important",
              color: "white",
            },
            // "& .MuiDataGrid-row:nth-of-type(odd)": {
            //   backgroundColor: "#f5f5f5",  // رنگ پس‌زمینه برای سطرهای فرد
            // },
            // "& .MuiDataGrid-row:nth-of-type(even)": {
            //   backgroundColor: "#ffffff",  // رنگ پس‌زمینه برای سطرهای زوج
            // },
          }}
          hideFooter={hideFooter}
          autoHeight={false}
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          //قدیم
          // rowSelectionModel={selectionModel}
          rowSelectionModel={selectionModel}
          rows={data ? data : []}
          columns={columns}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel: any) => setColumnVisibilityModel(newModel)}
          disableColumnMenu
          checkboxSelection={rowSelection ? rowSelection : false}
          rowSelection={true}
          //قدیم
          // onRowClick={(param:any) => {
          //   initOnRowClick(param.row);
          // }}
          onRowClick={(param: any) => {
            initOnRowClick(param.row);
          }}
        />
                    </div>

      </Grid>
    );
  }